import React from 'react';
import { scrollToUDS } from '../helpers';

const PaymentError = () => {
	return (
		<span
			className="ddc-font-size-xsmall text-muted text-decoration-underline"
			onClick={scrollToUDS}
			onKeyDown={(e) => e.key === 'Enter' && scrollToUDS()}
			role="button"
			tabIndex={0}
		>
			N/A
		</span>
	);
};

export default PaymentError;
